import { USER_SET, USER_UNSET, GET_USER } from './constants'

export function setUser(payload) {
  return {
    type: USER_SET,
    payload,
  }
}

export function unsetUser() {
  return {
    type: USER_UNSET,
  }
}

export function getUser(payload) {
  return {
    type: GET_USER,
    payload,
  }
}
